import { useQuery } from '@tanstack/react-query';
import { METHOD, sendJSONRequest } from '@/state/http-request.helpers';
import { ServerError } from '@/types/errors/server.error';
import { useAuth } from '@clerk/clerk-react';

export const EMAIL_OPT_OUTS_QUERY_KEY = 'email-opt-outs';

export interface EmailOptOutDto {
  id: string;
  email: string;
  organization: {
    _id: string;
    name: string;
  };
  createdAt: string;
  silencedAt?: string;
}

export const useGetEmailOptOutsQuery = () => {
  const { getToken, isLoaded, isSignedIn } = useAuth();

  return useQuery({
    queryKey: [EMAIL_OPT_OUTS_QUERY_KEY],
    queryFn: async () => {
      const token = await getToken();
      return getEmailOptOuts(token ?? '');
    },
    enabled: isLoaded && Boolean(isSignedIn),
    staleTime: 5 * 60_000,
    retry: (failureCount, error) => {
      if (error instanceof ServerError && error.statusCode === 429) {
        return false;
      }
      return failureCount < 2;
    },
  });
};

const getEmailOptOuts = async (token: string): Promise<EmailOptOutDto[]> => {
  const url = `${import.meta.env.VITE_API_URL}/email-preferences`;
  return sendJSONRequest({ url, method: METHOD.GET, token });
};
